import React from 'react';
import PolicyWrapper from '../components/PolicyWrapper';

const PrivacyPolicy = () => {
  return (
    <PolicyWrapper title="Privacy" subtitle="Policy">
      <p className="mt-4 text-gray-700 mb-10 text-center">
        Your privacy is important to us. This policy explains how we collect, use, and protect your information.
      </p>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Information We Collect</h2>
        <p className="text-gray-800 mb-4">
          We collect information you provide directly to us, such as when you create an account, 
          place an order, sign up for our newsletter, or contact us for support.
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-800">
          <li>Name, email address, and contact information</li>
          <li>Shipping and billing addresses</li>
          <li>Payment information (processed securely through Shopify)</li>
          <li>Vehicle information for product compatibility</li>
          <li>Communication preferences</li>
        </ul>
      </div>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">How We Use Your Information</h2>
        <p className="text-gray-800 mb-4">
          We use the information we collect to:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-800">
          <li>Process and fulfill your orders</li>
          <li>Provide customer support and technical assistance</li>
          <li>Send order confirmations and shipping updates</li>
          <li>Send marketing communications (only with your consent)</li>
          <li>Improve our products and services</li>
          <li>Comply with legal obligations</li>
        </ul>
      </div>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Shopify Integration</h2>
        <p className="text-gray-800 mb-4">
          Our online store is powered by Shopify, a trusted ecommerce platform. When you make a purchase:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-800">
          <li>Payment information is processed securely through Shopify's payment gateways</li>
          <li>Order data is stored in Shopify's secure systems</li>
          <li>We have access to order information for fulfillment and customer service</li>
          <li>Shopify's privacy practices apply to their handling of your data</li>
        </ul>
      </div>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Email Newsletter</h2>
        <p className="text-gray-800 mb-4">
          When you sign up for our newsletter, you consent to receive:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-800">
          <li>Product updates and new releases</li>
          <li>Installation tips and guides</li>
          <li>Special offers and promotions</li>
          <li>Company news and updates</li>
        </ul>
        <p className="text-gray-800 mt-4">
          You can unsubscribe at any time by clicking the unsubscribe link in our emails 
          or contacting us directly.
        </p>
      </div>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Data Protection</h2>
        <p className="text-gray-800 mb-4">
          We implement appropriate security measures to protect your personal information:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-800">
          <li>Secure SSL encryption for all data transmission</li>
          <li>Limited access to personal information on a need-to-know basis</li>
          <li>Regular security assessments and updates</li>
          <li>Secure storage of customer data</li>
        </ul>
      </div>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Your Rights</h2>
        <p className="text-gray-800 mb-4">
          You have the right to:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-gray-800">
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your data</li>
          <li>Opt out of marketing communications</li>
          <li>File a complaint with relevant authorities</li>
        </ul>
      </div>

      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Contact Us</h2>
        <p className="text-gray-800 mb-4">
          If you have any questions about this Privacy Policy or our data practices, 
          please contact us at:
        </p>
        <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-gray-800">Taco Garage</p>
          <p className="text-gray-800">1409 Broadway, Suite 101</p>
          <p className="text-gray-800">Chula Vista, CA 91911</p>
          <p className="text-red-600">info@tacogarage.com</p>
        </div>
      </div>

      <div className="mt-12 p-6 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-sm text-gray-800">
          <strong>Last updated:</strong> {new Date().toLocaleDateString()}
        </p>
      </div>
    </PolicyWrapper>
  );
};

export default PrivacyPolicy;
